import React from 'react';
import { TransactionType } from 'globals/types';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import FsExpenditureTableCategoryRow, {
  FsExpenditureTableCategoryRowProps,
} from './FsExpenditureTableCategoryRow/FsExpenditureTableCategoryRow';

export interface FsExpenditureTableDataProps {
  rows?: FsExpenditureTableCategoryRowProps[];
  transactionType?: TransactionType;
}

const FsExpenditureTable: React.FC<FsExpenditureTableDataProps> = ({
  rows = [],
  transactionType,
}) => {
  return (
    <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
      {rows.map(({ id, ...props }) => (
        <FsExpenditureTableCategoryRow
          data-test="expenditure-table-category-row"
          key={id}
          id={id}
          transactionType={transactionType}
          {...props}
        />
      ))}
    </FsMinWidthScrollBox>
  );
};

export default FsExpenditureTable;
